<h2 class="text-xl font-bold mt-16">رزرو اقامتگاه‌ های متنوع در سراسر ایران</h2>
<p class="text-muted text-xs !font-extralight leading-8 my-3">
      اگر به دنبال رزرو اقامتگاه برای تعطیلات یا سفر کاری خود هستید، جای درستی آمده‌اید. ایران هتل آنلاین ارائه‌دهنده‌ی
      طیف
      گسترده‌ای از ویلا، کلبه، سوئیت و اقامتگاه‌ های بوم‌گردی در تمامی مناطق ایران است. برای انواع اقامتگاه‌ها،
      گزینه‌های
      اقتصادی تا لوکس ارائه شده و برای هر سلیقه و بودجه‌ای گزینه‌ای برای ارائه وجود دارد.
</p>
<h2 class="text-xl font-bold">اجاره ویلا، کلبه و اقامتگاه بوم گردی برای تمامی سلیقه ها</h2>
<p class="text-muted text-xs !font-extralight leading-8 my-3">
      ایران هتل آنلاین انواع مختلفی از اقامتگاه را برای رزرو در اختیار شما قرار می‌دهد. از ویلاهای استخردار با طراحی
      مدرن و
      امکانات کامل تا ویلاهای ساحلی که دسترسی مستقیم به دریا را فراهم می‌کنند. همچنین، کلبه‌های چوبی و کلبه‌های جنگلی
      برای
      علاقه‌مندان به طبیعت‌گردی و آرامش محیا هستند. برای کسانی که به دنبال تجربه‌ای خاص‌تر هستند، امکان رزرو اقامتگاه
      های بوم
      گردی با فضا و امکانات سنتی نیز فراهم است.
</p>


<div class="{{showCollapseInfo ? 'block' : 'hidden'}}">

      <h2 class="text-xl font-bold">رزرو اقامتگاه‌ های اقتصادی و لوکس در سراسر ایران</h2>
      <p class="text-muted text-xs !font-extralight leading-8 my-3">
            ایران هتل آنلاین با هدف ارائه‌ی بهترین خدمات به گردشگران عزیز، رزرو اقامتگاه‌هایی را فراهم کرده‌ که هم از
            نظر اقتصادی و
            هم لوکس بودن، برای تمامی سلیقه‌ها و نیازها مورد قبول باشد. چه به دنبال یک اقامتگاه بوم‌گردی در مناطق روستایی
            و با هزینه
            مناسب باشید، چه یک ویلا لوکس در شهرهای بزرگ با امکانات بی‌نظیر، ایران هتل آنلاین گزینه‌های مناسبی برای شما
            تدارک دیده
            است. تمامی اقامتگاه‌ها با رعایت استانداردهای بالا و ارائه‌ی خدمات متنوع، تجربه‌ای راحت و دلپذیر را برای شما
            تضمین
            می‌کنند.
      </p>
      <h2 class="text-xl font-bold">رزرو اقامتگاه در کوتاه‌ترین زمان ممکن</h2>
      <p class="text-muted text-xs !font-extralight leading-8 my-3">
            ایران هتل آنلاین اهمیت زیادی به راحتی و سرعت، هنگام رزرو اقامتگاه می‌دهد. با استفاده از وبسایت می‌توانید
            به‌سرعت و با
            چند کلیک ساده، نوع اقامتگاه مورد نظر خود را انتخاب کرده و رزرو خود را نهایی کنید. وبسایت ایران هتل آنلاین به
            گونه‌ای
            طراحی شده که تجربه‌ی کاربری راحت و بدون دردسر را برای شما فراهم کند. همچنین، تیم پشتیبانی همواره آماده‌ی
            پاسخگویی به
            سوالات و کمک به شما در هر مرحله از فرآیند رزرو است.
      </p>
      <h2 class="text-xl font-bold">چرا ایران هتل آنلاین بهترین گزینه برای رزرو اقامتگاه است؟</h2>
      <div class="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3 mt-6">
            <div>

                  <h3 class="text-xl font-bold"> تنوع بالا:</h3>
                  <p class="text-muted text-xs !font-extralight leading-8 my-3">
                        از ویلاهای استخردار تا کلبه‌های جنگلی، برای تمامی سلیقه‌ها گزینه‌های متنوعی برای انتخاب وجود
                        دارد.
                  </p>
            </div>
            <div>

                  <h3 class="text-xl font-bold">کیفیت تضمینی:</h3>
                  <p class="text-muted text-xs !font-extralight leading-8 my-3">
                        : تمامی اقامتگاه‌ها دارای استانداردهای بالا و امکانات کامل هستند و شما می‌توانید در صفحه هر
                        اقامتگاه امکانات موجود را
                        مشاهده نمایید.
                  </p>
            </div>
            <div>

                  <h3 class="text-xl font-bold">پشتیبانی 24 ساعته:</h3>
                  <p class="text-muted text-xs !font-extralight leading-8 my-3">
                        تیم پشتیبانی ایران هتل آنلاین در تمامی روزهای هفته به صورت شبانه روزی آماده پاسخگویی به سوالات و
                        نیازهای شماست.

                  </p>
            </div>

            <div>
                  <h3 class="text-xl font-bold">قیمت‌های رقابتی:
                  </h3>
                  <p class="text-muted text-xs !font-extralight leading-8 my-3">
                        بهترین اقامتگاه‌ها در سراسر ایران را با مناسب‌ترین قیمت‌ می‌توانید با چند کلیک ساده رزرو کنید.


                  </p>
            </div>
            <div>
                  <h3 class="text-xl font-bold">رزرو آسان:</h3>
                  <p class="text-muted text-xs !font-extralight leading-8 my-3">
                        فرآیند رزرو اقامتگاه سریع و بدون دردسر برای راحتی شما در نظر گرفته شده تا تجربه دلپذیری از
                        فرايند رزرو خود داشته باشید.
                  </p>

            </div>

      </div>
</div>
<div class="w-full float-left text-left">
      <button class="text-blue-500 flex items-center float-left" (click)="showCollapseInfo = !showCollapseInfo">
            مشاهده {{showCollapseInfo ? 'کمتر' : 'بیشتر'}}
            <i class="{{showCollapseInfo ? 'ico-Up' : 'ico-Down'}}  text-2xl"></i>
      </button>
</div>